import React from 'react';
import { usePostMeta } from './usePostMeta';
import { SelectIsValid } from '../validations/locationIsValid';
import { useLocationStore } from '../state/storeLocation';
import { useConditional } from '../state/storeConditional ';

export const usePostControlFromUI  = () => {
	const [ mncm_selected, Setmncm_selected ] =
		React.useState< SelectIsValid >();
	const [ oaac_selected, Setoaac_selected ] =
		React.useState< SelectIsValid >();
	const [ hlm_selected, Sethlm_selected ] = React.useState< SelectIsValid >();
	const [ mfc_selected, Setmfc_selected ] = React.useState< SelectIsValid >();
	const [ LocationSelected, SetLocationSelected ] = React.useState<SelectIsValid>();
	const [ month_selected, SetMonth_selected ] =
		React.useState< SelectIsValid >();
	const mncm_update = useLocationStore( ( state ) => state.mncm_selected );
	const oaac_update = useLocationStore( ( state ) => state.oaac_selected );
	const hlm_update = useLocationStore( ( state ) => state.hlm_selected );
	const mfc_update = useLocationStore( ( state ) => state.mfc_selected );
	const updateMonth = useLocationStore( ( state ) => state.updateMonth );
	const {isReadyGenerator, isReadyToPost } = useConditional();

	// const Generate = useTuneStore( ( state ) => state.Generate );

	const updateTheMonthOnly = (month) => {
		return new Promise<void>((resolve, reject) => {
			if (!month?.name || !isReadyGenerator) {
				return resolve(); // Return resolved promise if conditions aren't met
			}
	
			try {
				const convert = {
					meta: "month",
					value: month as string,
				};
	
				appendDataPost(convert); // This is synchronous
				SetMonth_selected({
					value: {
						method: '',
						name: '',
					},
					meta: '',
				});
	
				resolve(); // Mark the promise as completed
			} catch (error) {
				console.error("Error in updateTheMonthOnly:", error);
				reject(error); // Reject the promise on error
			}
		});
	};
	
	
	
	

	const { appendDataPost } = usePostMeta();
	React.useEffect( () => {
		if ( month_selected?.value?.name && isReadyGenerator && isReadyToPost   ) {
			const convert = {
				meta: month_selected.meta,
				value: month_selected.value as string,
			};
			appendDataPost( convert );
			SetMonth_selected( {
				value: {
					method: '',
					name: '',
				},
				meta: '',
			} );
		}
		if ( mncm_selected?.value?.name && isReadyGenerator && isReadyToPost ) {
			const convert = {
				meta: mncm_selected.meta,
				value: mncm_selected.value as string,
			};
			appendDataPost( convert );
			Setmncm_selected( {
				value: {
					method: '',
					name: '',
				},
				meta: '',
			} );
		}
		if ( oaac_selected?.value?.name && isReadyGenerator && isReadyToPost  ) {
			const convert = {
				meta: oaac_selected.meta,
				value: oaac_selected.value as string,
			};
			appendDataPost( convert );
			Setoaac_selected( {
				value: {
					method: '',
					name: '',
				},
				meta: '',
			} );
		}
		if ( hlm_selected?.value?.name && isReadyGenerator && isReadyToPost  ) {
			const convert = {
				meta: hlm_selected.meta,
				value: hlm_selected.value as string,
			};
			appendDataPost( convert );
			Sethlm_selected( {
				value: {
					method: '',
					name: '',
				},
				meta: '',
			} );
		}

		if ( mfc_selected?.value?.name && isReadyGenerator && isReadyToPost ) {
			const convert = {
				meta: mfc_selected.meta,
				value: mfc_selected.value as string,
			};
			appendDataPost( convert );
			Setmfc_selected( {
				value: {
					method: '',
					name: '',
				},
				meta: '',
			} );
		}
		if ( LocationSelected?.meta && isReadyGenerator && isReadyToPost  ) {
			const convert = {
				meta: "location",
				value: LocationSelected.value as string,
			};
			appendDataPost( convert );
			
			SetLocationSelected( {
				value: {
					method: '',
					name: '',
				},
				meta: '',
			})
			
		}


	}, [ isReadyGenerator, isReadyToPost ] );

	const getSelectedFromUI = ( data ) => {
		
		
		if ( data.meta === 'mncm_selected' ) {
			Setmncm_selected( data );
			mncm_update( data.value );
		}

		if ( data.meta === 'oaac_selected' ) {
			Setoaac_selected( data );
			oaac_update( data.value );
		}
		if ( data.meta === 'hlm_selected' ) {
			Sethlm_selected( data );
			hlm_update( data.value );
		}

		if ( data.meta === 'mfc_selected' ) {
			Setmfc_selected( data );
			mfc_update( data.value );
		}
		if ( data.meta === 'month' ) {
			SetMonth_selected( data );
			updateMonth( data?.value );
			
		}
		if ( data.meta === 'location' ) {
			
			SetLocationSelected( data );
			// updateCustomLocationData( data.value );
			// CustomLocationUpdate( data.value );
		}

	};

	return { getSelectedFromUI,updateTheMonthOnly };
};
